import values from 'lodash/fp/values';
import types from 'config/types/path';
import languages from 'config/types/language';

export const globalParentPath = types.LANGUAGE_EDITION;

export const hostnameRegex = /\.(babbel\.(cn|com))$/;

// A few notes on the path exposed here as they will go through a few transformations:
// First, those paths will go through a lodash.template function to replace entities with <%= %> in the getPathMap selector
// Second, all paths will be prefixed with the LANGUAGE_EDITION path
// Finally, those paths will be used by path-to-regexp and react-router
export default {
  [types.LANGUAGE_EDITION]: `/:language(${values(languages).join('|')})/magazine`,
  [types.HOME]: '/',
  [types.PAGE]: '/:root*/:slug',
  [types.CONTENT_ITEM_SINGLE]: '/:slug',
  [types.CONTENT_ARCHIVE]: '/:contentType(<%= contentTypes %>)',
  [types.CATEGORY_ARCHIVE]: '/category/:slug/:contentType(<%= contentTypes %>)?',
  [types.TERM_ARCHIVE]: '/tags/:slug/:contentType(<%= contentTypes %>)?',
  [types.AUTHOR_ARCHIVE]: '/contributors/:slug',
  [types.SEARCH_ARCHIVE]: '/search/:page([1-9]\\d*)?',
};
